import { fileToBase64, base64ToFile, checkIfEmptyObject, checkDataForStep5_STRAIN, areObjectsEqual } from "helpers/helpers";
import objectsSchema from "schemas/objectsSchema";

export const prepareDataCheckStatus = opportunityId => {
   return {
      opportunityID: opportunityId
   };
};

export const prepareDataGetOffers = data => {
   const codSIRUTA = data?.codSIRUTA ? data.codSIRUTA : JSON.parse(localStorage.getItem("sessionStepsState"))?.step1.codSIRUTA;
   return {
      codSIRUTA: codSIRUTA,
   };
};

export const prepareDataStep3 = data => {
   const tipCetatenie = data.tipCetatenie;

   return {
      pe_firstname: data.prenume,
      pe_lastname: data.nume,
      telephone1: tipCetatenie === "ROMAN" ? "07" + data.telefon : data.telefon,
      emailaddress1: data.email,
      CNP: tipCetatenie === "ROMAN" ? data.cnp : "",
      semnatura: data.semnatura,
      // donotsendmm: data.newsletter === true ? false : true,
      // allowstudyresearch: data.analytics,
      codSIRUTA: data.step1.codSIRUTA,
      codoferta: data.step2.cod,
      judet: data.step1.judet, // ADAUGAT ULTERIOR - 12.04.2023
      localitate: data.step1.localitate, // ADAUGAT ULTERIOR - 12.04.2023
      cetatenie: tipCetatenie === "ROMAN" ? "romana" : "straina", // ADAUGAT ULTERIOR - 12.04.2023 Cetatean_STRAIN
      tara: tipCetatenie === "STRAIN" ? data.tara : "", // ADAUGAT ULTERIOR - 12.07.2023 Cetatean_STRAIN
      NIF: tipCetatenie === "STRAIN" ? data.nif : "", // ADAUGAT ULTERIOR - 12.07.2023 Cetatean_STRAIN
   };
};

export const prepareDataStep4 = data => {
   return {
      opportunityID: data.opportunityId,
      PIF: true,
      // existaGazLaAdresa: data.beneficieziInPrezent,
      // schimbareTitular: data.schimbiTitular,
      // PEFurnizorActual: data.premierEnergyTitular,
   };
};

export const prepareDataStep4PIF = async data => {
   let factura = "";
   let dovadaPlata = "";

   if (data.fileFacturaPIF && data.fileFacturaPIF instanceof File) factura = await fileToBase64(data.fileFacturaPIF);
   if (checkIfEmptyObject(data.fileFacturaPIF)) factura = "";
   if (data.fileFacturaPIF && typeof data.fileFacturaPIF === "string") factura = data.fileFacturaPIF;

   if (data.fileDovadaPlata && data.fileDovadaPlata instanceof File) dovadaPlata = await fileToBase64(data.fileDovadaPlata);
   if (checkIfEmptyObject(data.fileDovadaPlata)) dovadaPlata = "";
   if (data.fileDovadaPlata && typeof data.fileDovadaPlata === "string") dovadaPlata = data.fileDovadaPlata;

   // const formData = new FormData();
   // if (data.fileFacturaPIF && data.fileFacturaPIF instanceof File) {
   //    formData.append("factura", data.fileFacturaPIF);
   // } else {
   //    formData.append("factura", base64ToFile(data.fileFacturaPIF));
   // }
   //
   // if (data.fileDovadaPlata && data.fileDovadaPlata instanceof File) {
   //    formData.append("dovadaPlata", data.fileDovadaPlata);
   // } else {
   //    formData.append("dovadaPlata", base64ToFile(data.fileDovadaPlata));
   // }
   //
   //
   //
   // formData.append("PID", true);
   // formData.append("opportunityID", data.opportunityId);
   // return formData;

   return {
      opportunityID: data.opportunityId,
      PIF: true,
      factura : factura,
      dovadaPlata: dovadaPlata,
   };
};


export const prepareDataStep5 = data => {
   const formData = new FormData();
   if (data.fileCI && data.fileCI instanceof File) {
      formData.append("fileCI", data.fileCI);
   } else {
      formData.append("fileCI", base64ToFile(data.fileCI));
   }
   formData.append("opportunityID", data.opportunityId);
   return formData;
};

export const prepareDataStep5_STRAIN = async data => {
   return {
      opportunityID: data.opportunityId,
      nif: await checkDataForStep5_STRAIN(data.fileNIF),
      pasaport: await checkDataForStep5_STRAIN(data.filePasaport),
      permisDeSedere: await checkDataForStep5_STRAIN(data.filePermisSedere),
      alteDocumente: await checkDataForStep5_STRAIN(data.fileAlteDocumente),
   };
};

export const prepareDataStep6 = data => {
   // console.log('prepareDataStep6', data );
   return {
      opportunityID: data.opportunityId,
      donotsendmm: data.step3.newsletter === true ? false : true,
      allowstudyresearch: data.step3.analytics,
      dateIdentificareClient: {
         nume: data.nume,
         prenume: data.prenume,
         serieCI: data.serieCI, //Cetatean_ROMAN
         numarCI: data.numarCI, //Cetatean_ROMAN
         emisDe: data.emisDeCI, //Cetatean_ROMAN
         emisLa: data.emisLaCI, //Cetatean_ROMAN
         expiraLa: data.expiraLaCI, //Cetatean_ROMAN
         cnp: data.cnp, //Cetatean_ROMAN
         numarPasaport: data.nrPasaport, //Cetatean_STRAIN
         taraEmitenta: data.taraEmitenta, //Cetatean_STRAIN
         dataEmitere: data.emisLaPasaport, //Cetatean_STRAIN
         dataExpirare: data.expiraLaPasaport, //Cetatean_STRAIN
         nif: data.nif, //Cetatean_STRAIN
      },
      adresaDomiciliu: {
         judet: data.adresaConsumDomiciliu ? data.consum.judet : data.domiciliu.judet,
         localitate: data.adresaConsumDomiciliu ? data.consum.localitate : data.domiciliu.localitate,
         tipStrada: data.adresaConsumDomiciliu ? data.consum.tipStrada : data.domiciliu.tipStrada,
         numeStrada: data.adresaConsumDomiciliu ? data.consum.strada : data.domiciliu.strada,
         numar: data.adresaConsumDomiciliu ? data.consum.numar : data.domiciliu.numar,
         bloc: data.adresaConsumDomiciliu ? data.consum.bloc : data.domiciliu.bloc,
         scara: data.adresaConsumDomiciliu ? data.consum.scara : data.domiciliu.scara,
         etaj: data.adresaConsumDomiciliu ? data.consum.etaj : data.domiciliu.etaj,
         apartament: data.adresaConsumDomiciliu ? data.consum.apartament : data.domiciliu.apartament,
         codPostal: data.adresaConsumDomiciliu ? data.consum.codPostal : data.domiciliu.codPostal,
      },
      // adresaDeConsum: {
      //    judet: data.consum.judet,
      //    localitate: data.consum.localitate,
      //    tipStrada: data.consum.tipStrada,
      //    numeStrada: data.consum.strada,
      //    numar: data.consum.numar,
      //    bloc: data.consum.bloc,
      //    scara: data.consum.scara,
      //    etaj: data.consum.etaj,
      //    apartament: data.consum.apartament,
      //    codPostal: data.consum.codPostal,
      //    codSIRUTA: data.consum.codSIRUTA,
      // },
      adresaDeCorespondenta: {
         judet: data.corespondenta.judet,
         localitate: data.corespondenta.localitate,
         tipStrada: data.corespondenta.tipStrada,
         numeStrada: data.corespondenta.strada,
         numar: data.corespondenta.numar,
         bloc: data.corespondenta.bloc,
         scara: data.corespondenta.scara,
         etaj: data.corespondenta.etaj,
         apartament: data.corespondenta.apartament,
         codPostal: data.corespondenta.codPostal,
      },
      acordFacturaElectronica: data.facturaMail,
      telefon: data.tipCetatenie === "ROMAN" ? "07" + data.telefon : data.telefon,
      email: data.email,
      codoferta: data.step2.cod,
   };
};

export const prepareDataStep7 = data => {
   const formData = new FormData();
   if (data.fileCLCPOD && data.fileCLCPOD instanceof File) {
      formData.append("fileCLCPOD", data.fileCLCPOD);
   } else {
      formData.append("fileCLCPOD", base64ToFile(data.fileCLCPOD));
   }
   formData.append("opportunityID", data.opportunityId);
   return formData;
};

export const prepareDataStep7PIF = async (data, isPIF) => {
   let document = "";

   if (data.fileCLCPOD && data.fileCLCPOD instanceof File) document = await fileToBase64(data.fileCLCPOD);
   if (checkIfEmptyObject(data.fileCLCPOD)) document = "";
   if (data.fileCLCPOD && typeof data.fileCLCPOD === "string") document = data.fileCLCPOD;


   return {
      opportunityID: data.opportunityId,
      PIF: isPIF,
      document : document,
   };
};

export const prepareDataStep8 = async data => {
   let pozaIndexContor = "";

   // console.log('preppas8',data)

   if (data.indexContorPhoto && data.indexContorPhoto instanceof File) pozaIndexContor = await fileToBase64(data.indexContorPhoto);
   if (checkIfEmptyObject(data.indexContorPhoto)) pozaIndexContor = "";
   if (data.indexContorPhoto && typeof data.indexContorPhoto === "string") pozaIndexContor = data.indexContorPhoto;

   let documenteProprietate = [];
   if (data.fileCoProprietar && Object.getPrototypeOf(data.fileCoProprietar) !== Object.prototype) {
      for (let i = 0; i < data.fileCoProprietar.length; i++) {
         if (!checkIfEmptyObject(data.fileCoProprietar[i])) documenteProprietate.push(await fileToBase64(data.fileCoProprietar[i]));
      }
   }
   let valabilitateChirie = "";
   if (data.calitateDetinator === "chirias" || data.calitateDetinator === "comodator") {
      const valabilitateChirieInitial = new Date(data.valabilitateChirie);
      valabilitateChirie =
         valabilitateChirieInitial.getDate() +
         "/" +
         parseInt(valabilitateChirieInitial.getMonth() + 1) +
         "/" +
         valabilitateChirieInitial.getFullYear();
   }

   const isGeneralConvention = areObjectsEqual(objectsSchema[`indexLuniSchema${data.categorieConsum}`], data.indexLuni);
   const tipConventie = isGeneralConvention ? "Conventie generala" : "Conventie consum";

   return {
      opportunityID: data.opportunityId,
      cr15d_existagazlaadresa: data.beneficieziInPrezent,
      cr15d_schimbaretitular: data.isPIF ? false : data.schimbiTitular,
      cr15d_pefurnizoractual: data.isPIF ? false : data.premierEnergyTitular,
      tipProprietar: data.calitateDetinator,
      tipProprietarPanaLa: valabilitateChirie,
      documentProprietate: documenteProprietate,
      unitateDeMasura: data.unitateMasura,
      categorieConsum: data.categorieConsum,
      consumIanuarie: data.indexLuni.ianuarie,
      consumFebruarie: data.indexLuni.februarie,
      consumMartie: data.indexLuni.martie,
      consumAprilie: data.indexLuni.aprilie,
      consumMai: data.indexLuni.mai,
      consumIunie: data.indexLuni.iunie,
      consumIulie: data.indexLuni.iulie,
      consumAugust: data.indexLuni.august,
      consumSeptembrie: data.indexLuni.septembrie,
      consumOctombrie: data.indexLuni.octombrie,
      consumNoiembrie: data.indexLuni.noiembrie,
      consumDecembrie: data.indexLuni.decembrie,
      indexContor: data.indexContorManual,
      pozaContor: pozaIndexContor,
      dataIncepereFurnizare: data.dataLivrare,
      CLC: data.pod,
      tipConventie: tipConventie,
      adresaDeConsum: {
         judet: data.consum.judet,
         localitate: data.consum.localitate,
         tipStrada: data.consum.tipStrada,
         numeStrada: data.consum.strada,
         numar: data.consum.numar,
         bloc: data.consum.bloc,
         scara: data.consum.scara,
         etaj: data.consum.etaj,
         apartament: data.consum.apartament,
         codPostal: data.consum.codPostal,
         codSIRUTA: data.consum.codSIRUTA,
      },
   };
};

export const prepareDataStep9 = data => {
   return {
      opportunityID: "6263dbee-167a-ed11-81ad-000d3aba38a7",
   };
};
